import styles from '../styles/gnb.scss';

export function setUser(wrapper: HTMLElement, name: string | null): void {
  const nick = wrapper.querySelector<HTMLSpanElement>(`.${styles.nick}`);
  const user = wrapper.querySelector<HTMLDivElement>(`.${styles.user}`);
  const login = wrapper.querySelector<HTMLAnchorElement>(`.${styles.login}`);
  const logout = wrapper.querySelector<HTMLAnchorElement>(`.${styles.logout}`);

  if (!nick || !user || !login || !logout) return;

  if (name) {
    user.style.display = '';
    nick.textContent = name;
    login.style.display = 'none';
    logout.style.display = '';
  } else {
    user.style.display = 'none';
    nick.textContent = name ?? '';
    login.style.display = '';
    logout.style.display = 'none';
  }
}
